import {
    REQUEST_HINT,
    RECEIVE_HINT,
    ERROR_HINT
} from '../types'
import _cloneDeep from 'lodash/cloneDeep'
import {initialFetchState} from "../../constants/defaultValues"
import {loadDataRefresh} from "../../constants/constants"

export default (state = {}, action = {}) => {
    const newState = _cloneDeep(state)

    switch(action.type) {
        case REQUEST_HINT:
            newState[action.identifier] = {
                ...initialFetchState,
                isFetching: true
            }
            return newState
        case RECEIVE_HINT:
            newState[action.identifier] = {
                ...newState[action.identifier],
                isFetching: false,
                data: action.payload,
                message: '',
                errors: {},
                validUntil: loadDataRefresh.never + Date.now()
            }
            return newState
        case ERROR_HINT:
            newState[action.identifier] = {
                ...newState[action.identifier],
                isFetching: false,
                data: {},
                message: action.errors.server || '',
                errors: action.errors
            }
            return newState
        default:
            return state
    }
}